<template>
  <div class="invoice-application-money" :style="{paddingTop: !isSass ? '16px' : '0'}">
    <div :class="['invoice-item', isEmpty ? '!w-full' : '!w-[70%]']">
      <img :src="taxStatistics.month.src" alt="">
      <div class="list">
        <div v-for="(v) in taxStatistics.month.list" :key="v.key" class="item">
          <div class="value">
            {{ v.value }}
          </div>
          <div class="label">
            {{ v.label }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="!isEmpty" class="invoice-item">
      <img :src="taxStatistics.year.src" alt="">
      <div class="list">
        <div v-for="(v) in taxStatistics.year.list" :key="v.key" class="item">
          <div class="value" :style="{color: v.key === 'yearInvoiceAmountRemaining' && Number(v.value) <= 500000 ? '#FF4D4F' : ''}">
            {{ v.value }}
          </div>
          <div class="label">
            {{ v.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ITaxSourceQuotaDetail } from '@core/main/types';
import { computed, PropType, ref, watch } from 'vue';
import { isNull } from '@core/tools';
import { useUserStore } from '@core/main';
import { ESystemType } from '@core/api';

const emit = defineEmits(['handleException']);

const props = defineProps({
  taxSourceQuota: {
    type: Object as PropType<ITaxSourceQuotaDetail>,
    default: () => ({}),
  },
  allWarningTotal: {
    type: Number,
    default: 0,
  },
});

const { state: userState } = useUserStore();

const taxStatistics = ref({
  month: {
    src: new URL('@core/main/assets/images/tax-payment-invoice/invoice-month.png', import.meta.url).href,
    list: [
      {
        label: '剩余开票张数',
        key: 'invoiceCountRemaining',
        value: '--',
      },
      {
        label: '已用额度(元)',
        key: 'invoiceUsedQuota',
        value: '--',
      },
      {
        label: '剩余额度(元)',
        key: 'invoiceAmountRemaining',
        value: '--',
      },
      {
        label: '月开票额度(元)',
        key: 'invoiceMonth',
        value: '--',
      },
      {
        label: '单张发票额度(元)',
        key: 'singleInvoiceQuota',
        value: '--',
      },
    ],
  },
  year: {
    src: new URL('@core/main/assets/images/tax-payment-invoice/invoice-year.png', import.meta.url).href,
    list: [
      {
        label: '剩余额度(元)',
        key: 'yearInvoiceAmountRemaining',  
        value: '--',
      },
      {
        label: '自然年开票额度(元)',
        key: 'yearInvoiceAmountLimit',
        value: '--',
      },
    ],
  },
});

const isSass = computed(() => userState.identity.systemType === ESystemType.SAAS);
const isEmpty = computed(() => taxStatistics.value.year.list?.every((v) => Number(v.value) === -1));

function fetchData(newVal: ITaxSourceQuotaDetail) {
  taxStatistics.value.month.list.forEach((v) => {
    v.value = isNull(newVal[v.key]) ? '--' : newVal[v.key];
  });

  taxStatistics.value.year.list.forEach((v) => {
    v.value = isNull(newVal[v.key]) ? '--' : newVal[v.key];
  });
}

watch(
  () => props.taxSourceQuota,
  (newVal) => {
    if (newVal) fetchData(newVal);
  },
  { immediate: true },
);
</script>

<style lang="scss" scoped>
.invoice-application-money {
  @apply w-full flex gap-x-3 px-[16px] mt-2;

  .invoice-item {
    @apply w-[70%] h-[100px] flex items-center gap-x-2 bg-[#F7FAFF] rounded border border-solid border-[#E9F3FF] px-3;

    img {
      @apply w-[18px] h-[72px];
    }

    .list {
      @apply flex-1 flex items-center gap-x-2;

      .item {
        @apply min-w-[145px] flex-1 h-[76px] bg-white rounded py-[14px] flex flex-col items-center justify-center;

        .value {
          @apply max-w-[215px] max-3xl:max-w-[145px] w-full text-center text-[var(--color-text-primary)] text-[18px] truncate;
        }

        .label {
          @apply text-[var(--color-text-desc)] text-[14px] flex items-center gap-x-1;

          &::before {
            @apply content-[''] w-[6px] !inline-block h-[6px] bg-[#6CA5F5] rounded-[50%];
          }
        }
      }
    }
  }

  .invoice-item:nth-of-type(2) {
    @apply w-[30%];

    .list .item .value {
      @apply max-w-[211px];
    }
  }
}
</style>
